export const PERCENTAGE_OF_GROSS_RADIO_BUTTON = 'percentage of gross radio button';
export const SELECT_ALLOCATION_UNIT_RADIO_BUTTON = 'select allocation unit radio button';



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/comp/ruleBuilder/allocationContainer/RadioButtonsConstants.js